module.exports = __webpack_public_path__ + "img/source_book-item8.5d7d5ada.png";